export const RISK_STYLES = {
  LOW: { text: "#059669", bg: "#D1FAE5", border: "#34D399" },
  MEDIUM: { text: "#D97706", bg: "#FEF3C7", border: "#FBBF24" },
  HIGH: { text: "#EA580C", bg: "#FFEDD5", border: "#FB923C" },
  CRITICAL: { text: "#DC2626", bg: "#FEE2E2", border: "#F87171" },
};

export const STATUS_STYLES = {
  "Analysis Complete": { text: "#059669", bg: "#D1FAE5", border: "#34D399" },
  Analyzing: { text: "#2563EB", bg: "#DBEAFE", border: "#93C5FD" },
  Failed: { text: "#DC2626", bg: "#FEE2E2", border: "#F87171" },
  Uploaded: { text: "#475569", bg: "#F1F5F9", border: "#E2E8F0" },
};

export const CLASS_STYLES = {
  FACT: { text: "#047857", bg: "#ECFDF5", border: "#6EE7B7" },
  ESTIMATE: { text: "#2563EB", bg: "#EFF6FF", border: "#93C5FD" },
  BENCHMARK: { text: "#7C3AED", bg: "#F5F3FF", border: "#C4B5FD" },
  RECOMMENDATION: { text: "#B45309", bg: "#FFFBEB", border: "#FCD34D" },
};

export const OUTCOME_STYLES = {
  won: { text: "#047857", bg: "#ECFDF5", border: "#6EE7B7", label: "Won" },
  lost: { text: "#DC2626", bg: "#FEE2E2", border: "#F87171", label: "Lost" },
  pending: { text: "#64748B", bg: "#F1F5F9", border: "#CBD5E1", label: "Pending" },
};

export const OutcomeBadge = ({ value, testId }) => {
  const s = OUTCOME_STYLES[value] || OUTCOME_STYLES.pending;
  return (
    <span data-testid={testId}
      className="inline-flex items-center px-2 py-0.5 rounded text-[11px] font-semibold border whitespace-nowrap"
      style={{ color: s.text, backgroundColor: s.bg, borderColor: s.border }}>
      {s.label}
    </span>
  );
};

export function scoreColor(score) {
  if (score >= 80) return "#059669";
  if (score >= 70) return "#D97706";
  if (score >= 60) return "#EA580C";
  return "#DC2626";
}

function Badge({ value, styles, testId }) {
  const s = styles[value] || { text: "#475569", bg: "#F1F5F9", border: "#E2E8F0" };
  return (
    <span data-testid={testId}
      className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-semibold border whitespace-nowrap"
      style={{ color: s.text, backgroundColor: s.bg, borderColor: s.border }}>
      {value}
    </span>
  );
}

export const RiskBadge = ({ value, testId }) => <Badge value={value} styles={RISK_STYLES} testId={testId} />;
export const StatusBadge = ({ value, testId }) => <Badge value={value} styles={STATUS_STYLES} testId={testId} />;
export const ClassBadge = ({ value }) => (
  <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-bold tracking-wide border"
    style={{ ...(CLASS_STYLES[value] ? { color: CLASS_STYLES[value].text, backgroundColor: CLASS_STYLES[value].bg, borderColor: CLASS_STYLES[value].border } : {}) }}>
    {value}
  </span>
);

export const PROJECT_TYPES = [
  "Control4", "Lutron Shades", "Lighting Control", "Networking/WiFi", "Audio/Video",
  "Security/Cameras", "Service Upgrade", "Full Home System", "Commercial AV", "Other",
];

export const COMPANY_TYPES = [
  "Residential AV / Automation", "Commercial AV", "Both Residential & Commercial",
  "Lighting / Shading Specialist", "Networking / IT", "Security Integration", "Other",
];
